const AffiliateSvg = ({
  height = 20,
  width = 20,
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Rounded Square Border */}
      <rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="2.5" />

      {/* Left Code Arrow */}
      <path
        d="M10 9L7 12L10 15"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Right Code Arrow */}
      <path
        d="M14 9L17 12L14 15"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default AffiliateSvg;
